import React from 'react';
import { Table, Space } from 'antd';
import { stringMixin } from "../../../utils/strings";
import DeltaLine from "../../../charts/DeltaLine";
const SectorDeviationTable = ({ deviations }) => {
  // Find the min and max delta values to normalize the deltas
  const minDelta = Math.min(...deviations.map(d => d.delta));
  const maxDelta = Math.max(...deviations.map(d => d.delta));

  const columns = [
    {
      title: 'Sector',
      dataIndex: 'name',
      key: 'name',
      render: (text) => <span className={'font-semibold'}>{stringMixin.fmt(text)}</span>,
    },
    {
      title: 'Weight',
      dataIndex: 'originalWeight',
      key: 'originalWeight',
      render: (originalWeight, record) => {
        const delta = record.newWeight - originalWeight;
        const prefix = delta > 0 ? '+' : '';
        return (
            <div className={'flex flex-row align-middle'}>
              <span className={'font-medium text-sm'}>{(record.newWeight * 100).toFixed(2)}%</span>
              <span className={'text-xs pl-3'}>
                {prefix}{stringMixin.pct(delta, { prec: 1 })}
              </span>
            </div>
        )
      },
    },
    {
      title: 'Delta',
      dataIndex: 'delta',
      key: 'delta',
      render: (delta) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <DeltaLine delta={delta} minDelta={minDelta} maxDelta={maxDelta} />  {/* Add the DeltaLine component */}
          <span style={{ marginLeft: 8, color: delta > 0 ? 'var(--green)' : 'var(--red)' }}>
            {delta > 0 ? `+${stringMixin.pct(delta, { prec: 1 })}` : stringMixin.pct(delta, { prec: 1 })}
          </span>
        </div>
      ),
      width: 180
    },
  ];

  const sortedDeviations = deviations.sort((a, b) => b.newWeight - a.newWeight);

  return (
    <div>
      <Table
        dataSource={sortedDeviations}
        columns={columns}
        rowKey="name"
        // className={'striped'}
        pagination={false}
      />
    </div>
  );
};

export default SectorDeviationTable;
